module.exports = __webpack_public_path__ + "grootstatic/media/hindustan-petroleum.dae824c0.svg";